import { render, staticRenderFns } from "./equipamentTable.vue?vue&type=template&id=54d28969&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./equipamentTable.vue?vue&type=style&index=0&id=54d28969&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d28969",
  null
  
)

export default component.exports